import { withPluginApi as __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__ } from "discourse/lib/plugin-api";
import { default as __WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_default__ } from "discourse-i18n";
import { default as __WEBPACK_EXTERNAL_MODULE__components_waze_header_chat_icon_5bfe0204_default__ } from "../components/waze-header-chat-icon";
/******/ var __webpack_modules__ = ({

/***/ 221
(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = void 0;
exports.T3 = getColorScheme;
var WazeColorScheme;
(function (WazeColorScheme) {
    WazeColorScheme["Light"] = "light";
    WazeColorScheme["Dark"] = "dark";
})(WazeColorScheme || (__webpack_unused_export__ = WazeColorScheme = {}));
function getColorScheme() {
    return __webpack_require__.g
        .getComputedStyle(__webpack_require__.g.document.documentElement)
        .getPropertyValue("--scheme-type")
        .trim();
}
//# sourceMappingURL=color-scheme.js.map

/***/ }

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/global */
/******/ (() => {
/******/ 	__webpack_require__.g = (function() {
/******/ 		if (typeof globalThis === 'object') return globalThis;
/******/ 		try {
/******/ 			return this || new Function('return this')();
/******/ 		} catch (e) {
/******/ 			if (typeof window === 'object') return window;
/******/ 		}
/******/ 	})();
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

;// external "discourse/lib/plugin-api"

;// external "discourse-i18n"

;// external "../components/waze-header-chat-icon"

// EXTERNAL MODULE: ../../shared/waze-theme/lib/color-scheme.js
var color_scheme = __webpack_require__(221);
;// ./src/plugin/assets/javascripts/discourse/initializers/waze-chat-initializer.ts





/* harmony default export */ const waze_chat_initializer = ({
    name: "waze-chat",
    initialize(container, app) {
        const appEvents = container.lookup("service:app-events");
        __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__("1.34.0", (api) => {
            if (window.ChatSDK && api.getCurrentUser()) {
                const chatContainer = document.createElement("div");
                chatContainer.setAttribute("class", "wz-chat-container");
                document.body.append(chatContainer);
                const chatSDKPromise = window.ChatSDK.create({
                    parentNode: chatContainer,
                    appIdentifierName: "WAZE_DISCUSS",
                    locale: __WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_default__.locale,
                    theme: (0,color_scheme/* getColorScheme */.T3)(),
                    zIndex: "999",
                    androidInteractiveWidgetWorkaroundAllowed: true,
                });
                chatSDKPromise.then((sdk) => {
                    sdk.subscribe(() => {
                        appEvents.trigger("waze:chat:unread");
                    });
                    appEvents.trigger("waze:chat:ready", sdk);
                });
                app.register("service:waze-chat-sdk-promise", chatSDKPromise, {
                    instantiate: false,
                });
                api.headerIcons.add("waze-header-chat-icon", __WEBPACK_EXTERNAL_MODULE__components_waze_header_chat_icon_5bfe0204_default__);
            }
        });
    },
});

export { waze_chat_initializer as default };
